export default {
  denied: '未授权使用定位',
  fail: '定位失败',
  timeout: '定位超时'
}
